import React from "react";
import header from "../../../Assets/Styles/header.module.css";
import facebook from "../../../Assets/Images/Icons/SocialMedia/facebook.png";
import linkedin from "../../../Assets/Images/Icons/SocialMedia/linkedin.png";
import twitter from "../../../Assets/Images/Icons/SocialMedia/twitter.png";

const SubHeader = () => {
  return (
    <section className="bg-[#F4F6FD] hidden max-md:block ">
      <nav className="custom_size  font-roboto ">
        <div
          className={`flex py-4 justify-between items-center  ${header.subHeader} `}
        >
          <div className="flex justify-center items-center">
            <p className="pr-5 max-h-[20px] border-r border-[#B1B1B1] flex  justify-center items-center ">
              <i className="fa-solid fa-phone-volume pr-2"></i>
              <a
                href="tel:01540343775"
                className="text-sm text-[#67687A] font-medium"
              >
                {" "}
                01540343775
              </a>
            </p>
            <p className="pr-5 max-h-[20px] border-r border-[#B1B1B1] flex  justify-center items-center ">
              <i className="fa-solid fa-map-location-dot pl-5 pr-2"></i>
              <span className="text-sm text-[#67687A] font-medium">
                Dhaka, Bangladesh{" "}
              </span>
            </p>
            <p className="pr-5 max-h-[20px] border-r border-[#B1B1B1] flex  justify-center items-center ">
              <i className="fa-solid pl-5 pr-2 fa-envelope"></i>
              <a
                href="mailto:infoitghor24@gmail.com"
                className="text-sm text-[#67687A] font-medium"
              >
                infoitghor24@gmail.com
              </a>
            </p>
          </div>
          <div className="pl-5 max-h-[20px] flex  justify-center items-center ">
            <span className="text-[#909BAE] pr-3 text-[15px] font-medium">
              Follow Us:
            </span>
            <a
              className="pr-3"
              href="https://www.facebook.com/itghar.bd"
              target="blank"
            >
              {" "}
              <img src={facebook} alt="global_it_master_facebook" />
            </a>
          </div>
        </div>
      </nav>
    </section>
  );
};

export default SubHeader;
